domains.$inject = ['graph']

export default function domains(graph) {
  var domainsFactory = {}

  // domain schools/school admins
  domainsFactory.UI = {
    loading: false,
    domains: [],
    domainNames: [],
    lastFetched: null,
    showError: false,
    errorTitle: 'Error Fetching Domains',
    errorMessage: null
  }
  domainsFactory.refreshDomains = function() {
    this.UI.loading = true
    graph.getDomains().then(
      function(domains) {
        this.UI.domains = domains
        this.UI.domainNames = domains.map(function(d) {
          return d.name
        })
        this.UI.loading = false
        this.UI.lastFetched = Date.now()
      }.bind(this),
      function(reason) {
        this.UI.loading = false
        this.UI.showError = true
        this.UI.errorMessage = reason
      }
    )
  }

  return domainsFactory
}
